var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"open_ssl"},[_vm._t("default"),_c('wx-open-launch-weapp',{attrs:{"id":"launch-webapp","username":_vm.username,"path":_vm.path}},[_c('script',{attrs:{"type":"text/wxtag-template"}},[_vm._v(" <style> .btn{ width: 100%; height: 200px; opacity: 0; } </style> <button class=\"btn\"></button> ")])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }